<template>
  <div class="flex flex-row" :class="containerClasses">
    <div
      v-for="member of displayedMembers"
      :key="member.id"
      class="box-content rounded-full bg-inherit"
      :class="paddingClasses"
    >
      <BaseMemberAvatar :member="member" :size="size" :omit-tooltip="omitTooltip" />
    </div>
    <div
      v-if="numberOfHiddenMembers > 0"
      class="box-content rounded-full bg-inherit"
      :class="paddingClasses"
    >
      <div
        class="text-on-primary-container bg-primary-container flex shrink-0 items-center justify-center rounded-full"
        :class="sizeClasses"
      >
        +{{ numberOfHiddenMembers }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import type { AvatarMemberAttributes, AvatarSize } from './avatar-props'
  import BaseMemberAvatar from './BaseMemberAvatar.vue'

  interface Props {
    members: ReadonlyArray<AvatarMemberAttributes>
    omitTooltip?: boolean
    size?: AvatarSize
    displayLimit?: number
  }

  const { size = '40', displayLimit = 4, members } = defineProps<Props>()

  const displayedMembers = computed(() => {
    return members.slice(0, displayLimit)
  })

  const numberOfHiddenMembers = computed(() => {
    return members.length - displayLimit
  })

  const paddingClasses = computed(() => {
    if (size == '160') {
      return 'p-1.5'
    }
    if (size == '96') {
      return 'p-1'
    }
    return 'p-0.5'
  })

  const sizeClasses = computed(() => {
    if (size == '160') {
      return 'h-40 w-40 text-display-large'
    }
    if (size == '128') {
      return 'h-32 w-32 text-title-large'
    }
    if (size == '96') {
      return 'h-24 w-24 text-title-large'
    }
    if (size == '80') {
      return 'h-20 w-20 text-headline-large'
    }
    if (size == '64') {
      return 'h-16 w-16 text-title-large'
    }
    if (size == '56') {
      return 'h-14 w-14 text-title-large'
    }
    if (size == '32') {
      return 'h-8 w-8 text-label-large'
    }
    if (size == '24') {
      return 'h-6 w-6 text-label-small'
    }
    return 'h-10 w-10 text-label-large'
  })

  const containerClasses = computed(() => {
    if (size == '160') {
      return '-space-x-16'
    }
    if (size == '128') {
      return '-space-x-11'
    }
    if (size == '96') {
      return '-space-x-10'
    }
    if (size == '80') {
      return '-space-x-7'
    }
    if (size == '64') {
      return '-space-x-6'
    }
    if (size == '56') {
      return '-space-x-5.5'
    }
    if (size == '32') {
      return '-space-x-3.5'
    }
    if (size == '24') {
      return '-space-x-3'
    }
    return '-space-x-4'
  })
</script>
